import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { userPrivileges } from '../../../apollo/cache';
import { useReactiveVar } from '@apollo/client';
import PrivilegeNames from '../../../constants/privilegeNames';
import NotFoundPage from '../../notFound/NotfoundPage';
import ReleaseNotesPage from '../../releaseNotes/components/ReleaseNotesPage';
import ResourcePage from '../../resources/components/ResourcesPage';
import SubmitFeedbackPage from '../../feedback/components/SubmitFeedbackPage';
import NoPermissionsPage from '../../unauthorized/NoPermissionsPage.js';
import CalendarPage from '../../calendar/components/CalendarPage';
import AccountPage from '../../account/components/AccountPage';
import EditEventPage from '../../calendar/components/CalendarEvents/EditEventPage/EditEventPage';
import RouteParamReloader from './RouteParamReloader';
import RedirectPage from '../../redirectPage/components/RedirectPage';
import LandingPageWrapper from '../components/LandingPageWrapper';
import InvoicesPage from '../../invoices/components/Invoices';

const RoutesForATMSystemRoles = () => {
  const privileges = useReactiveVar(userPrivileges);
  if (!privileges?.length) {
    return null;
  }

  return (
    <Routes>
      {privileges.includes(PrivilegeNames.Resources) && (
        <Route path='/resources' element={<LandingPageWrapper page={ResourcePage} />} />
      )}
      {privileges.includes(PrivilegeNames.Calendar) && (
        <Route path='/calendar'>
          <Route path='' element={<CalendarPage />} />
          <Route
            path='edit-event/:eventId'
            element={<RouteParamReloader component={EditEventPage} />}
          />
        </Route>
      )}
      {privileges.includes(PrivilegeNames.AppraiserProfile) && (
        <Route path='/account' element={<AccountPage />} />
      )}
      {privileges.includes(PrivilegeNames.ReleaseNotes) && (
        <Route path='/release-notes' element={<ReleaseNotesPage />} />
      )}
      {privileges.includes(PrivilegeNames.SubmitFeedback) && (
        <Route path='/submit-feedback' element={<SubmitFeedbackPage />} />
      )}

      {privileges.includes(PrivilegeNames.Invoices) && (
        <Route path='/invoices' element={<InvoicesPage />} />
      )}

      <Route path='/redirect-page/:redirectingData' element={<RedirectPage />} />

      <Route path='/' element={<Navigate to='/resources' replace />} />
      <Route path='/page-not-found' element={<NotFoundPage />} />

      <Route path='/permissions' element={<NoPermissionsPage />} />
      <Route path='*' element={<Navigate to='/page-not-found' replace />} />
    </Routes>
  );
};

export default RoutesForATMSystemRoles;
